import { useMemo } from "react";
import { currentSessionProvider } from "../api/fastapi";

/**
 * Whether the current session signed in with Optro (the access token's
 * `provider` claim is "optro").
 *
 * Read once per mount: it decodes the access token out of localStorage, and the
 * claim cannot change while mounted. It survives token refresh (the SSO refresh
 * path forwards the whole claims dict), and every path that could change it
 * either hard-reloads (sign-in, workspace switch, session expiry) or unmounts
 * the app shell (logout, the /auth callbacks that set the token before
 * navigating).
 */
export function useSignedInWithOptro(): boolean {
  return useMemo(() => currentSessionProvider() === "optro", []);
}
